module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/account/generate-invoice/generate-invoice.component.css
// module id = ./src/app/account/generate-invoice/generate-invoice.component.css
// module chunks = main